<template>
  <div class="nav" v-show="drawer">
    <!-- 遮罩层 -->
    <div class="mask" @click="close" @touchmove.stop.prevent></div>
    <!-- 内容 -->
    <div class="warpper" :style="{ width: drawer ? '240px' : '0px' }">
      <!-- 社交媒体图标 -->
      <div class="social-icons">
        <a class="qqgroup" @click="copyQQGroup" style="cursor: pointer;" title="复制QQ群号" rel="noopener noreferrer nofollow">
          <svg-icon icon-class="qqgroup" />
        </a>
        <a class="bilibili" href="https://space.bilibili.com/472852116" target="_blank" title="bilibili" rel="noopener noreferrer nofollow">
          <svg-icon icon-class="Bzhan" />
        </a>
        <a class="qq" @click="copyQQ" style="cursor: pointer;" title="复制QQ号" rel="noopener noreferrer nofollow">
          <svg-icon icon-class="qq" />
        </a>
        <a class="wechat" @click="copyWechat" style="cursor: pointer;" title="复制微信号" rel="noopener noreferrer nofollow">
          <svg-icon icon-class="wechat" />
        </a>
        <a class="weibo" href="https://weibo.com/CS2CLUB" target="_blank" title="微博" rel="noopener noreferrer nofollow">
          <svg-icon icon-class="weibo" />
        </a>
      </div>
      <hr />
      <!-- 页面导航 -->
      <div class="menu-container">
        <div class="menus-item">
          <router-link to="/" :class="{ active: currentPath === '/' }">
            <i class="fas fa-home" style="color: #409EFF;"></i> 首页
          </router-link>
        </div>
        <div class="menus-item">
          <router-link :to="{ path: '/case' }" :class="{ active: currentPath === '/case' }">
            <i class="fas fa-box-open" style="color: #F56C6C;"></i> 武器箱&大行动
          </router-link>
        </div>
        <div class="menus-item">
          <router-link :to="{ path: '/valvestandings' }" :class="{ active: currentPath === '/valvestandings' }">
            <i class="fas fa-trophy" style="color: #FFD700;"></i>V社战队排名
          </router-link>
        </div>
        <div class="menus-item">
          <router-link :to="{ path: '/sites' }" :class="{ active: currentPath === '/sites' }">
            <i class="fas fa-compass" style="color: #9B59B6;"></i>CS2导航站
          </router-link>
        </div>
        <!-- <div class="menus-item">
          <router-link
            :to="{ path: '/category', query: { id: 12, name: '教程攻略' } }"
            :class="{ active: currentPath === '/category' }"
          >
            教程攻略
          </router-link>
        </div> -->
        <div class="menus-item">
          <router-link :to="{ path: '/updatenotes' }" :class="{ active: currentPath === '/updatenotes' }">
            <i class="fas fa-history" style="color: #67C23A;"></i>更新日志
          </router-link>
        </div>
        <div class="menus-item">
          <router-link :to="{ path: '/workshop'}" :class="{ active: currentPath === '/workshop' }">
            <i class="fas fa-paint-brush" style="color: #E6A23C;"></i>创意工坊
          </router-link>
        </div>
        <div class="menus-item">
          <router-link :to="{ path: '/command'}" :class="{ active: currentPath === '/command' }">
            <i class="fas fa-code" style="color: #909399;"></i>指令大全
          </router-link>
        </div>
        <!-- <div class="menus-item">
          <router-link :to="{ path: '/tag' }" :class="{ active: currentPath === '/tag' }">
            标签
          </router-link>
        </div> -->
        <div class="menus-item">
          <router-link :to="{ path: '/about' }" :class="{ active: currentPath === '/about' }">
            <i class="fas fa-user" style="color: #3498DB;"></i>关于作者
          </router-link>
        </div>
      </div>
      <hr />
      <!-- 公告信息 -->
      <div class="notice-container">
        <div class="notice-title">
          <i class="fas fa-bullhorn" style="color: #f59e0b;"></i>
          <span>公告信息</span>
        </div>
        <div class="notice-content">
          <span>{{ $store.state.webSiteInfo.bulletin }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { logout } from "@/api";
import { getUser, removeUser } from "@/utils/auth";
export default {
  data: function () {
    return {
      img: process.env.VUE_APP_IMG_API,
      path: "",
    };
  },
  computed: {
    drawer: {
      set(value) {
        this.$store.state.drawer = value;
      },
      get() {
        return this.$store.state.drawer;
      },
    },
    isLogin() {
      let user = getUser();
      return user != null;
    },
    currentPath() {
      return this.$route.path;
    }
  },

  methods: {
       handleClike(val) {
      this.$router.push({
        path: val,
        hash: window.location.hash.substr(1),
      });
    },
    close() {
      this.$store.state.drawer = false;
    },
    openLogin() {
      this.$store.state.loginFlag = true;
    },
    logout() {
      //如果在个人中心则跳回上一页
      if (this.$route.path === "/user") {
        this.$router.go(-1);
      }
      logout()
        .then((res) => {
          removeUser();
          this.$store.commit('logout');
          this.$toast({ type: "success", message: "注销成功" });
          setTimeout(() => {
            location.reload();
          }, 1000);
        })
        .catch((err) => {
          console.log(err);
          // 即使后端接口失败，也执行登出操作
          removeUser();
          this.$store.commit('logout');
          location.reload();
        });
    },
    copyQQ() {
      const qqNumber = "1277198796";
      navigator.clipboard.writeText(qqNumber).then(() => {
        this.$toast({ type: "success", message: "QQ号已复制到剪贴板" });
      }).catch(() => {
        this.$toast({ type: "error", message: "复制失败，请手动复制" });
      });
    },
    copyWechat() {
      const wechatNumber = "wangdayouzi13";
      navigator.clipboard.writeText(wechatNumber).then(() => {
        this.$toast({ type: "success", message: "微信号已复制到剪贴板" });
      }).catch(() => {
        this.$toast({ type: "error", message: "复制失败，请手动复制" });
      });
    },
    copyQQGroup() {
      const qqGroupNumber = "603807485";
      navigator.clipboard.writeText(qqGroupNumber).then(() => {
        this.$toast({ type: "success", message: "QQ群号已复制到剪贴板" });
      }).catch(() => {
        this.$toast({ type: "error", message: "复制失败，请手动复制" });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  color: var(--text-color);
}

.nav {
  height: 100%;

  .mask {
    background: rgba(101, 101, 101, 0.8); //设置透明度 ，改最后一个数值，0-1
    width: 100%;
    height: 100%;
    z-index: 9;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }

  .warpper {
    font-weight: 700;
    font-size: 1.2rem;
    background-color: var(--background-color);
    position: fixed;
    top: 0;
    z-index: 10;
    height: 100vh;
    animation: 0.8s ease 0s 1 normal none running sidebarItem;

    .blogger-info {
      padding: 26px 30px 0;
      text-align: center;
      z-index: 99;
    }

    .blog-info-wrapper {
      display: flex;
      align-items: center;
      padding: 12px 10px 0;

      .blog-info-data {
        flex: 1;
        line-height: 2;
        text-align: center;

        a {
          text-decoration: none;
        }
      }
    }

    hr {
      border: none;
      height: 1px;
      background: linear-gradient(to right, 
        rgba(0, 123, 255, 0), 
        rgba(0, 123, 255, 0.3) 20%, 
        rgba(0, 123, 255, 0.5) 50%, 
        rgba(0, 123, 255, 0.3) 80%, 
        rgba(0, 123, 255, 0)
      );
      margin: 8px 15px;
      box-shadow: 0 0 3px rgba(0, 123, 255, 0.2);
    }

    .menu-container {
      padding: 5px 10px 40px;
      // overflow: scroll;

      .menus-item {
        a {
          padding: 7px 20px;
          display: block;
          line-height: 2;
          text-decoration: none;
          border-radius: 8px;
          margin: 4px 0;
          transition: all 0.3s ease;

          &:hover {
            background-color: rgba(0, 123, 255, 0.1);
          }

          &.active {
            background-color: #007bff;
            color: white;
          }
        }

        i {
          margin-right: 1rem;
        }
      }
    }

    .social-icons {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 15px 10px 10px;
      gap: 12px;
      
      a {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 28px;
        height: 28px;
        border-radius: 50%;
        transition: all 0.3s ease;
        
        &:hover {
          transform: translateY(-2px);
        }
        
        .svg-icon {
          width: 16px;
          height: 16px;
        }
      }
      
      .qqgroup {
        color: #56b6e7;
      }
      
      .bilibili {
        color: #fb7299;
      }
      
      .qq {
        color: #56b6e7;
      }
      
      .wechat {
        color: #07c160;
      }
      
      .weibo {
        color: #e6162d;
      }
    }

    .notice-container {
      margin: 10px;
      background-color: var(--background-color);

      .notice-title {
        padding: 10px 15px;
        display: flex;
        align-items: center;
        gap: 8px;

        i {
          font-size: 14px;
        }

        span {
          color: var(--text-color);
          font-size: 13px;
          font-weight: 500;
        }
      }

      .notice-content {
        padding: 12px 15px;

        span {
          display: -webkit-box;
          -webkit-line-clamp: 4;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 12px;
          color: var(--text-color);
          line-height: 1.6;
        }
      }
    }
  }
}

@keyframes sidebarItem {
  0% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(0);
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 0.8;
  }
  50% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0.8;
  }
}
</style>
